export class HttpApiError {
  static Unauthorized = 401;

  static Forbidden = 403;

  static NotFound = 404;

  static TimeOut = 408;

  static Conflict = 409;

  static InternalServerError = 500;

  static UnknownError = 0;
}
